export const MIN_CROP_ZOOM = 1;
export const MAX_CROP_ZOOM = 4;
export const CROP_ZOOM_STEP = 0.25;

/**
 * Clamp crop zoom so pinch and buttons stay inside a usable range.
 *
 * @param {number} zoom
 * @returns {number}
 */
export const clampCropZoom = zoom => {
  const next = Number(zoom);
  if (!Number.isFinite(next)) {
    return MIN_CROP_ZOOM;
  }
  return Math.min(MAX_CROP_ZOOM, Math.max(MIN_CROP_ZOOM, next));
};

/**
 * Distance between two touch points for pinch-zoom.
 *
 * @param {{clientX: number, clientY: number}} a
 * @param {{clientY: number, clientX: number}} b
 * @returns {number}
 */
export const pinchDistance = (a, b) => {
  if (!a || !b) {
    return 0;
  }
  const dx = a.clientX - b.clientX;
  const dy = a.clientY - b.clientY;
  return Math.hypot(dx, dy);
};

/**
 * Cover-fit scale so the image always fills the crop frame at zoom 1.
 *
 * @param {number} imageWidth
 * @param {number} imageHeight
 * @param {number} frameWidth
 * @param {number} frameHeight
 * @returns {number}
 */
export const coverScale = (imageWidth, imageHeight, frameWidth, frameHeight) => {
  if (!imageWidth || !imageHeight || !frameWidth || !frameHeight) {
    return 1;
  }
  return Math.max(frameWidth / imageWidth, frameHeight / imageHeight);
};

/**
 * Keep the image covering the crop frame after pan.
 *
 * @param {Object} params
 * @returns {{x: number, y: number}}
 */
export const clampCropOffset = ({
  x,
  y,
  imageWidth,
  imageHeight,
  frameWidth,
  frameHeight,
  zoom,
} = {}) => {
  const scale = coverScale(imageWidth, imageHeight, frameWidth, frameHeight) * clampCropZoom(zoom);
  const drawnWidth = imageWidth * scale;
  const drawnHeight = imageHeight * scale;
  const maxX = Math.max(0, (drawnWidth - frameWidth) / 2);
  const maxY = Math.max(0, (drawnHeight - frameHeight) / 2);
  return {
    x: Math.min(maxX, Math.max(-maxX, x || 0)),
    y: Math.min(maxY, Math.max(-maxY, y || 0)),
  };
};
